<template>
    <div class="columns column is-1 is-offset-11">
              <sc-button  text="Ajuda"
                          theme="default"
                          type="button"
                          @click="callHelpScreen"/>

    </div>
</template>

<script>
import {
  ScButton,
} from '@intelipost-js/secure-components';

export default {
  name: 'help-button',

  methods: {
    callHelpScreen() {
      window.open('https://ajuda.intelipost.com.br/app_total', '_blank');
    },
  },

  components: {
    ScButton,
  },
};
</script>




// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/help-button/HelpButton.vue